import {Component, OnInit} from '@angular/core';
import {BreadcrumbComponent} from "@shared/components/breadcrumb/breadcrumb.component";
import {MatIcon} from "@angular/material/icon";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {ActivatedRoute} from "@angular/router";
import {ReactiveFormsModule} from "@angular/forms";
import {PrescriptionData} from "@core/models/PrescriptionData";
import {PrescriptionService} from "@core/http/table-data-services/prescription.service";
import {IDetalleReceta, IReceta} from "@core/interfaces/receta-data";
import {MatList, MatListItem} from "@angular/material/list";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {MatDivider} from "@angular/material/divider";
import {CapitalizePipe} from "@core/pipes/capitalize.pipe";
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {CatalogsService} from "@core/http/catalogs.service";
import {HttpErrorResponse} from "@angular/common/http";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {PatientDetails} from "@core/models/PatientDetails";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {MedicamentoTypeLabelPipe} from "@core/pipes/medicamento-type-label.pipe";
import {downloadPrescriptionPdf, generatePrescriptionPdfBase64, openPrintWindow} from "@shared/utils/window.utils";

@Component({
  selector: 'app-prescription-details',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    MatIcon,
    ReactiveFormsModule,
    MatList,
    MatListItem,
    CapitalizePipe,
    NgClass,
    MatButton,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MedicamentoTypeLabelPipe,
    NgIf
  ],
  templateUrl: './prescription-details.component.html',
  styleUrl: './prescription-details.component.scss'
})
export class PrescriptionDetailsComponent implements OnInit {
  param: string | null = null;
  param2: string | null = null;
  estatusReceta: string | null = null;
  userImage: string | null = null;
  prescription: PrescriptionData;
  receta: IReceta;
  detalles: IDetalleReceta[];
  currentPin: string | null = null;

  optionsDuration = [
    {value: "YEAR", label: "AÑO(S)"},
    {value: "MONTH", label: "MES(ES)"},
    {value: "WEEK", label: "SEMANA(S)"},
    {value: "DAY", label: "DIA(S)"},
    {value: "HOUR", label: "HORA(S)"},
    {value: "MINUTE", label: "MINUTO(S)"}
  ];

  constructor(
    private route: ActivatedRoute,
    private service: PrescriptionService,
    private catalogsService: CatalogsService,
    private httpMsgHandler: HttpMesageHandlerService,
  ) {
    this.route.paramMap.subscribe(params => {
      const param = params.get('param');
      this.param = param ? atob(param) : null;

      const param2 = params.get('par');
      this.param2 = param2 ? atob(param2) : null;

      const param3 = params.get('stat');
      this.estatusReceta = param3 ? atob(param3) : null;

    });
    this.userImage = 'assets/images/user/imgUSer.png';
    this.prescription = new PrescriptionData();
    this.receta = {} as IReceta;
    this.detalles = [];
  }

  searchPatientByName(name: string) {
    this.catalogsService.getPatientsByName(name).subscribe({
      next: (data) => {

        const patient: PatientDetails | undefined = data.data.find(value => value.idPaciente = this.receta.idPaciente);
        if (patient?.imagen) {
          this.userImage = 'data:image/png;base64,' + patient?.imagen
        }
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  isFolioValido(): boolean {
    const folio = this.receta?.folio?.toString().trim().toLowerCase();
    return folio !== null && folio !== undefined && folio !== '' && folio !== 'sin folio';
  }


  getDetails(idReceta: string, pin: string | null): void {
    this.service.getPrescriptionDetails(idReceta, pin).subscribe({
      next: (data) => {
        if (!data?.data?.receta) return;

        this.searchPatientByName(data.data.receta.nombresPaciente);

        const receta = {
          ...data.data.receta,
          edad: this.calculateAge(data.data.receta.fechaNacimientoPaciente),
          fechaCreacion: this.param2 ?? data.data.receta.fechaCreacion,
          fechaNacimientoPaciente: data.data.receta.fechaNacimientoPaciente.split('T')[0]
        };

        const detalles = data.data.detalles.map(detalle => ({
          ...detalle,
          periodoInicio: detalle.periodoInicio.split('T')[0],
          periodoTerminacion: detalle.periodoTerminacion.split('T')[0],
          unidadDuracion: this.optionsDuration.find(
            opt => opt.value === detalle.unidadDuracion
          )?.label!
        }));

        this.receta = receta;
        this.detalles = detalles;
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  ngOnInit(): void {
    const pinFromState = (history.state?.pin ?? null) as string | null;
    this.currentPin = pinFromState;

    this.getDetails(this.param!, pinFromState);
  }

  descargarPDF() {
    const {idReceta, idPaciente} = this.receta;

    this.catalogsService.getRecetaByIdReceta(idReceta, idPaciente, this.currentPin).subscribe({
      next: (res: string) => {
        void downloadPrescriptionPdf(res, `receta-${this.receta.folio || this.receta.idReceta}.pdf`);
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  enviarRecetaPorCorreo() {
    const { idReceta, idPaciente } = this.receta;

    this.catalogsService.getRecetaByIdReceta(idReceta, idPaciente, this.currentPin).subscribe({
      next: async (res: string) => {
        try {
          const pdfBase64 = await generatePrescriptionPdfBase64(res, {
            title: 'Enviando receta...',
            subtitle: 'Estamos preparando el PDF para correo'
          });

          this.service.enviarRecetaPorCorreo({ idReceta, pdfBase64 }).subscribe({
            next: (response) => this.httpMsgHandler.handleMsg(response as any),
            error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
          });
        } catch (error) {
          this.httpMsgHandler.handleMsg(error as HttpErrorResponse);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  printHtml(fullHtmlString: string): void {

    const printWidth = 1000;
    const printHeight = 800;

    const screenWidth = window.screen.width || 1920;
    const screenHeight = window.screen.height || 1080;

    const left = Math.max((screenWidth - printWidth) / 2, 0);
    const top = Math.max((screenHeight - printHeight) / 2, 0);

    const features = `width=${printWidth},height=${printHeight},top=${top},left=${left},resizable=yes,scrollbars=yes`;

    const printWindow = openPrintWindow(features);

    if (!printWindow) {
      return;
    }

    // rompe la relación con la ventana padre
    printWindow.opener = null;

    try {

      printWindow.document.open();
      printWindow.document.write(fullHtmlString);
      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };

    } catch (error) {
      printWindow.close();
    }
  }

  private calculateAge(fechaNacimiento: string): number {
    if (!fechaNacimiento) {
      return 0;
    }
    const birthDate = new Date(fechaNacimiento.split('T')[0]);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

}
